// extracted by mini-css-extract-plugin
export default {"wrapper":"N1Q2kQgijA7MrLu_2kmo","headerCommission":"Q1Z0rmKKvrzTCtWJRBev","headerCentered":"cpwBcK38VpJ3GyKNOvFH"};